import type { ReactNode } from 'react';

export function StepHeading({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <h2
      className={`text-2xl font-semibold tracking-tight text-gray-900 ${className ?? ''}`.trimEnd()}
    >
      {children}
    </h2>
  );
}
